export function jqHeaderMenu() {


  jQuery(function () {

    //navi SP
    var toggle = $(".js-toggle");
    var header = $(".l-header");
    var toggle_target = $(".js-toggle--target");

    //bodyのスクロール位置の格納
    //var state = false;
    //var scrollpos;

    //open
    function menuOpen() {
      toggle.addClass('is-active');
      header.addClass('is-active');
      toggle_target.slideToggle();
    }

    //close
    function menuClose() {
      toggle.removeClass('is-active');
      header.removeClass('is-active');
      toggle_target.slideToggle();
      //$('.menu').removeClass('is-openchild').removeClass('is-opengrand');
      //$('.menu').children().removeClass('is-open');
      //$('.menu').children().removeClass('is-active');
    }

    //is-fixedの制御
    // function swichFixed() {
    //   if (state == false) {
    //     scrollpos = $(window).scrollTop()
    //     $('body').addClass('is-fixed').css({ 'top': -scrollpos })
    //     state = true;
    //   } else {
    //     $('body').removeClass('is-fixed').css({ 'top': 0 }),
    //       window.scrollTo(0, scrollpos)
    //     state = false;
    //   }
    // }

    //toggle開閉
    toggle.on('click', function () {
      if (header.hasClass('is-active')) {
        menuClose();
      } else {
        menuOpen();
      }
      //swichFixed();
    });

    //navi sp
    if (window.matchMedia('(max-width: 767px)').matches) {
      // 親メニュー処理
      $('.menu_item--hasChildren').click(function () {
        $(this).toggleClass('menu_open');
        // メニュー表示/非表示
        $(this).next('.submenu').slideToggle();
      });
      // 子メニュー処理
      $('.menu_item--hasChildren').click(function (e) {
        // メニュー表示/非表示
        $(this).children('.submenu').slideToggle();
        e.stopPropagation();
      });
    }

    // //aタグでclose
    // $('.l-header a').on('click', function () {
    //   if (header.hasClass('is-active')) {
    //     //menuClose();
    //     //swichFixed();
    //   }
    // });

    //指定要素でclose
    $('.nav_close').on('click', function () {
      if (header.hasClass('is-active')) {
        menuClose();
        //swichFixed();
      }
    });



    //navi PC//////////////////////////////
    if (window.matchMedia('(min-width: 768px)').matches) {
      $(function () {
        $('.submenu').hide().css({'visibility':'visible'});
        $('ul.menu li.menu_item').hover(function () {
          $(this).find('.submenu').stop().slideDown().css({'display':'flex'});
        }, function () {
          $(this).find('.submenu').stop().slideUp();
        });
      })
    }

    //スクロールでheader非表示
    $(window).scroll(function() {
      let currentScrollTop = $(this).scrollTop();
      let header = $('.l-header');
      
      if (Math.abs(lastScrollTop - currentScrollTop) <= 100) return;
      
      if (currentScrollTop > lastScrollTop && currentScrollTop > 100) {
        header.addClass('is-hide');
      } else {
        header.removeClass('is-hide');
      }
      
      lastScrollTop = currentScrollTop;
    });

    let lastScrollTop = 0;


    //ヘッダーカラーの切り替え
    $(function () {
      var $win = $(window);
      var $header = $('.l-header');
      var $target = $('.l-section_wrap--white').first(); // 対象が複数なら調整

      if (!$target.length || !$header.length) return;

      function toggleHeaderClass() {
        var scrollTop = $win.scrollTop();
        var start = $target.offset().top;               // 要素の開始位置
        var end   = start + $target.outerHeight();      // 要素の終了位置（下端）

        if (scrollTop >= start && scrollTop < end) {
          $header.addClass('js-scroll-swich');
        } else {
          $header.removeClass('js-scroll-swich');
        }
      }

      $win.on('load scroll resize', toggleHeaderClass);
    });


    $(function() {
      // 全current削除
      $('.menu_item > a').removeClass('current');
      
      var currentPath = location.pathname.replace(/\/$/, '');

      $('.menu_item > a[href]').each(function() {
        var $a = $(this);
        var hrefAttr = $a.attr('href');
        
        // href正規化
        var cleanHref = hrefAttr.split('#')[0].split('?')[0];
        var $tempA = $('<a>').attr('href', cleanHref);
        var hrefPath = $tempA.prop('pathname').replace(/\/$/, '');

        if (hrefPath === '/') {
          // Home: 完全一致のみ
          if (currentPath === '/') {
            $a.addClass('current');
          }
        } else {
          // 他: currentPathにhrefPathが含まれている場合（親含む）
          if (currentPath.includes(hrefPath)) {
            $a.addClass('current');
          }
        }
      });
    });
    

  });//jQuery
}
